export { logoutContacts, logoutAdmins } from './services';
